import { __awaiter } from "tslib";
/** Represents an infinite loop that doesn't block the execution of the main program */
export default class NonBlockingLoop {
    /**
     * @param {Cyclable} cyclable - The object that implements the loop execution
     * @param {number} intervalMs - The amount of milliseconds between two iterations of the loop
     */
    constructor(cyclable, intervalMs = NonBlockingLoop.DEFAULT_INTERVAL_MS) {
        if (!cyclable) {
            throw new Error("Null or undefined cyclable");
        }
        else if (intervalMs < 1) {
            throw new Error("intervalMs must be greater than 0");
        }
        this.intervalId = null;
        this.cyclable = cyclable;
        this.intervalMs = intervalMs;
        this.isLocked = false;
    }
    /** Starts the execution of the loop */
    start() {
        if (this.intervalId !== null) {
            return;
        }
        this.intervalId = setInterval(() => __awaiter(this, void 0, void 0, function* () {
            if (this.isLocked) {
                return;
            }
            this.isLocked = true;
            yield this.cyclable.cycle();
            this.isLocked = false;
        }), this.intervalMs);
    }
    /** Stops the execution of the loop */
    stop() {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
}
/** The default amount of milliseconds between two iterations of the loop */
NonBlockingLoop.DEFAULT_INTERVAL_MS = 200;
